import { BaseEmitter } from 'kuker-emitters';
import Store, { Dispatch, Middleware, Reducer } from 'repatch';
import State from './core/State';

const createKukerEmitterMiddleware = (): Middleware => {
  const emit = BaseEmitter();

  return ((store: Store<State>) => (next: Dispatch<State>) => (reducer: Reducer<State>) => {
    const currentState = store.getState();
    const nextState = reducer(currentState);

    emit({
      type: 'State Mutation',
      state: nextState,
      icon: 'fa-archive',
    });

    return next((_) => nextState);
  }) as Middleware;
};

export default createKukerEmitterMiddleware;
